const Resources = () => {
    return (
        <div>
            <section>
                <h1>Hello! Welcome to EquiVate Resources Page</h1>
            </section>
        </div>
    
    )

}

export default Resources